import * as THREE from 'three'
import { loadModel } from '@/utils/loader'
import { applyMaterial } from '@/utils/material'

export default class Model extends THREE.Object3D {
  name = 'Model'

  constructor (path, done) {
    super()

    loadModel(path, gltf => {
      gltf.scene.traverse(obj => {
        if (obj.isMesh) {
          applyMaterial(obj)
        }
      })

      if (gltf.animations.length) {
        this.mixer = new THREE.AnimationMixer(gltf.scene)
        gltf.animations.forEach(clip => {
          this.mixer.clipAction(clip).play()
        })
      }

      this.add(gltf.scene)

      done && done()
    })
  }

  setTimeScale (timeScale) {
    if (this.mixer) {
      this.mixer.timeScale = timeScale
    }
  }

  setShadow (radius, color, opacity = 0.5) {
    this.shadow && this.remove(this.shadow)
    const geometry = new THREE.CircleGeometry(radius, 32)
    const material = new THREE.MeshBasicMaterial({ color, opacity, transparent: true })
    this.shadow = new THREE.Mesh(geometry, material)
    this.shadow.rotateX(-Math.PI / 2)
    this.add(this.shadow)
  }

  update (delta) {
    if (this.mixer) {
      this.mixer.update(delta)
    }
  }
}
